<template>
    <v-navigation-drawer absolute
                         :right="$vuetify.rtl"
                         :left="!$vuetify.rtl"
                         :height="drawerHeight"
                         width="350"
                         color="primary"
                         :value="drawerState"
                         app
                         class="transition-ease-in-out"
                         :style="{ 'box-shadow': drawerState ? '0 -5px 7px 1px rgba(0,0,0,0.5)' : '' }"
                         disable-resize-watcher
                         disable-route-watcher
                         floating
                         stateless
                         style="padding-top: 90px !important;"
    >
        <v-container fluid pa-0 fill-height>
            <v-row justify="center" align="center" no-gutters class="pa-5">
                <v-col cols="12" class="mb-2">
                    <div v-html="content"></div>
                </v-col>
            </v-row>
        </v-container>
    </v-navigation-drawer>
</template>

<script>
    export default {
        name: "AudioTranscriptSideDrawer",
        computed: {
            drawerHeight() {
                return window.innerHeight - 90;
            },
            drawerState() {
              return this.$store.state.media.transcriptActive;
            },
            content() {
              return this.$store.state.media.transcriptContent;
            }
        }
    }
</script>

<style scoped>

</style>